import { Icons } from '../../Icons/Icons';
import { Options, DescriptionPopover } from './components';

import styles from './styles.module.scss';

export const timelineTableColumns = (handleEdit, handleRemove, handleView) => [
  {
    title: 'Timeline',
    key: 'Name',
    dataIndex: 'Name',
    sorter: (a, b) => {
      if (a.Name < b.Name) return -1;
      if (a.Name > b.Name) return 1;
      return 0;
    },
    render: (value) => (
      <div className={styles.timelineName}>
        <Icons variant={Icons.TIMELINE} />
        <strong>{value}</strong>
      </div>
    ),
  },
  {
    title: '',
    width: 200,
    key: 'options',
    render: (_, timeline) => {
      return (
        <div className={styles.tableOptions}>
          <DescriptionPopover description={timeline?.Description} />
          <Options
            index={timeline?.index}
            editHandler={() => handleEdit(timeline.Id, timeline)}
            removeHandler={() => handleRemove(timeline)}
          />
        </div>
      );
    },
  },
];
